import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAssistant } from "../../components/support/AssistantWorkspace";

// Keep existing bookmarks; the conversation now lives outside page routes.
export default function SupportAssistant() {
  const assistant = useAssistant();
  const openAssistant = assistant?.openAssistant;
  useEffect(() => { openAssistant?.(); }, [openAssistant]);
  return <Navigate to="/onboarding" replace />;
}
